module.exports = __webpack_public_path__ + "static/media/d1a.c00a2890.png";